import { Link } from 'react-router-dom';
import { Icon } from '../../components/icon/icon';
import { CONST } from '../../constants/constant';
import './CenterSupportPage.scss';
import ROUTER from '../../routers/Routers';
import SearchComponent from '../../components/common/SearchComponent/SearchComponent';
import { useTranslation } from 'react-i18next';

const CenterSupportPage = () => {
  const { t } = useTranslation();
  return (
    <div className="center-support-page">
      <div className="flex lg:px-24 lg:py-32 p-16 flex-col items-center lg:gap-32 self-stretch">
        <div className="flex lg:p-60 p-16 px-24 md:px-16 h-[480px] flex-col lg:items-start justify-center items-center lg:gap-24 md:gap-16 self-stretch bg-primary-primary rounded-[16px]">
          <span className="text-headline-small-emphasized lg:text-headline-large-emphasized text-center text-white">
            {t('Support Center')}
          </span>
          <span className="text-body-medium lg:body-text-large text-center text-white">
            {t('Here, you will find answers to all your questions.')}
          </span>
          <SearchComponent className="w-full lg:w-[600px]" />
        </div>
      </div>
      <div className="flex py-32 lg:px-24 md:px-20 px-16 flex-col justify-center items-center lg:gap-40 gap-24 self-stretch bg-fills-white">
        <div className="flex self-stretch">
          <span className="text-headline-small-emphasized lg:text-headline-medium text-left">
            {t('Categories')}
          </span>
        </div>

        <div className="grid grid-rows-3 lg:grid-rows-1 lg:grid-cols-3 grid-cols-1 items-center justify-start gap-4">
          <Link
            to={ROUTER.DOCUMENTS.replace('/', '')}
            className="flex p-24 flex-col items-start gap-40 rounded-[24px] bg-fills-primary-varient self-stretch lg:col-span-1"
          >
            <div className="flex flex-col self-stretch items-start lg:gap-40 md:gap-32 gap-40 justify-between grow">
              <div className="flex p-16 justify-start items-center gap-8 rounded-[100px] bg-primary-primary shadow-border-widget">
                <span className="w-32 h-32 flex text-white">
                  <Icon.ICHelp />
                </span>
              </div>
              <div className="flex flex-col items-start gap-16">
                <span className="text-title-large-emphasized text-primary-primary">
                  {t('Design Guide')}
                </span>
                <span className="text-body-medium">
                  {t(
                    'Get familiar with the interface, explore the main features, and start creating your own space with ease.'
                  )}
                </span>
              </div>
            </div>
          </Link>
          <div className="lg:col-span-2 lg:row-span-1 row-span-2 grid grid-rows-2 gap-4">
            <div className="grid grid-cols-2 items-center justify-start gap-4">
              <Link
                to={ROUTER.SALES_POLICY.replace('/', '')}
                className="flex p-24 flex-col items-center gap-40 grow rounded-[24px] bg-fills-primary-varient self-stretch"
              >
                <div className="flex flex-col self-stretch items-start lg:gap-40 md:gap-32 gap-40 justify-between grow">
                  <div className="flex p-16 justify-start items-center gap-8 rounded-[100px] bg-primary-primary shadow-border-widget">
                    <span className="w-32 h-32 flex text-white">
                      <Icon.ICDescription />
                    </span>
                  </div>
                  <div className="flex flex-col items-start gap-16">
                    <span className="text-title-large-emphasized text-primary-primary">
                      {t('Sales policy')}
                    </span>
                    <span className="text-body-medium">
                      {t(
                        'Detailed information about your rights and responsibilities, ensuring a transparent and secure shopping and service experience.'
                      )}
                    </span>
                  </div>
                </div>
              </Link>
              <Link
                to={ROUTER.WARRANTY_POLICY.replace('/', '')}
                className="flex p-24 flex-col items-center gap-40 grow rounded-[24px] bg-fills-primary-varient self-stretch"
              >
                <div className="flex flex-col self-stretch items-start lg:gap-40 md:gap-32 gap-40 justify-between grow">
                  <div className="flex p-16 justify-start items-center gap-8 rounded-[100px] bg-primary-primary shadow-border-widget">
                    <span className="w-32 h-32 flex text-white">
                      <Icon.ICShiled />
                    </span>
                  </div>
                  <div className="flex flex-col items-start gap-16">
                    <span className="text-title-large-emphasized text-primary-primary">
                      {t('Warranty policy')}
                    </span>
                    <span className="text-body-medium">
                      {t(
                        'Detailed information about product warranty terms and coverage, effective immediately after payment is completed and the product is delivered.'
                      )}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
            <Link
              to={ROUTER.WEB_APP_TERMS_OF_USE.replace('/', '')}
              className="flex p-24 flex-col items-start gap-40 rounded-[24px] bg-fills-primary-varient self-stretch"
            >
              <div className="flex flex-col self-stretch items-start lg:gap-40 md:gap-32 gap-40 justify-between grow">
                <div className="flex p-16 justify-start items-center gap-8 rounded-[100px] bg-primary-primary shadow-border-widget">
                  <span className="w-32 h-32 flex text-white">
                    <Icon.ICManual />
                  </span>
                </div>
                <div className="flex flex-col items-start gap-16">
                  <span className="text-title-large-emphasized text-primary-primary">
                    {t('Web-App Terms of Use')}
                  </span>
                  <span className="text-body-medium">
                    {t(
                      'General terms and conditions for using the Fitta interior design application. By accessing the platform and placing an order, you agree to our terms and conditions.'
                    )}
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="flex md:py-32 lg:px-60 md:px-20 py-24 px-16 flex-col justify-center items-start md:gap-40 gap-24 self-stretch bg-fills-white">
        <span className="text-headline-small-emphasized lg:text-headline-medium">
          {t('Contact Us Directly')}
        </span>
        <div className="grid grid-rows-4 lg:grid-rows-1 lg:grid-cols-4 gap-16 self-stretch">
          <Link
            to={'tel:' + CONST.laNhaPhone}
            className="flex px-16 py-24 flex-col justify-center items-center gap-40 self-stretch rounded-[16px] border-[1px] border-solid border-outline-default-primary"
          >
            <span className="w-32 h-32 flex">
              <Icon.ICPhone />
            </span>
            <div className="flex flex-col items-center gap-8">
              <span className="text-body-medium" style={{ color: '#818589' }}>
                {t('24/7 Hotline')}
              </span>
              <span className="text-body-medium">{CONST.laNhaPhone}</span>
            </div>
          </Link>
          <Link
            to={'mailto:' + CONST.laNhaEmail}
            className="flex px-16 py-24 flex-col justify-center items-center gap-40 self-stretch rounded-[16px] border-[1px] border-solid border-outline-default-primary"
          >
            <span className="w-32 h-32 flex">
              <Icon.ICMail />
            </span>
            <div className="flex flex-col items-center gap-8">
              <span className="text-body-medium" style={{ color: '#818589' }}>
                Email
              </span>
              <span className="text-body-medium">{CONST.laNhaEmail}</span>
            </div>
          </Link>
          <Link
            to={CONST.laNhaFacebook}
            target="_blank"
            rel="noopener noreferrer"
            className="flex px-16 py-24 flex-col justify-center items-center gap-40 self-stretch rounded-[16px] border-[1px] border-solid border-outline-default-primary"
          >
            <span className="w-32 h-32 flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clipPath="url(#clip0_5245_20143)">
                  <path
                    d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 23.9859 5.85094 30.6053 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5434 6.25C21.2934 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.12 10.5 18.5 11.7334 18.5 13V16H22.9375L22.2281 20.625H18.5V31.8056C26.1491 30.6053 32 23.9859 32 16Z"
                    fill="#1877F2"
                  />
                  <path
                    d="M22.2281 20.625L22.9375 16H18.5V13C18.5 11.7334 19.12 10.5 21.1075 10.5H23.125V6.5625C23.125 6.5625 21.2934 6.25 19.5434 6.25C15.8888 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C15.1566 32.0648 16.8434 32.0648 18.5 31.8056V20.625H22.2281Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5245_20143">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="flex flex-col items-center gap-8">
              <span className="text-body-medium" style={{ color: '#818589' }}>
                Fanpage
              </span>
              <span className="text-body-medium max-w-[200px] truncate">
                {CONST.laNhaFacebook}
              </span>
            </div>
          </Link>
          <Link
            to={CONST.laNhaZalo}
            target="_blank"
            rel="noopener noreferrer"
            className="flex px-16 py-24 flex-col justify-center items-center gap-40 self-stretch rounded-[16px] border-[1px] border-solid border-outline-default-primary"
          >
            <span className="w-32 h-32 flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clipPath="url(#clip0_5245_36677)">
                  <path
                    d="M8.43126 26.0938V1.55426L7.4126 0.87207C3.0814 2.61077 0.0195312 6.84103 0.0195312 11.7939V20.2056C0.0195312 26.7095 5.292 31.982 11.7959 31.982H20.2077C24.1797 31.982 27.6798 30.0069 29.8113 26.993V26.0938H8.43126Z"
                    fill="#2962FF"
                  />
                  <path
                    d="M20.2076 0.0175781H11.7959C10.2439 0.0175781 8.7668 0.325447 7.40999 0.870527C4.60637 3.59256 2.54297 8.03227 2.54297 11.794C2.54297 17.4896 3.33031 20.824 5.6654 24.081C5.84709 24.3342 5.9657 24.6303 5.98168 24.9407C6.01785 25.6431 5.87317 26.93 4.60721 28.0883C4.47094 28.2128 4.55758 28.4408 4.74179 28.4484C5.53418 28.4829 7.13325 28.4366 8.7769 27.7107C9.24543 27.5037 9.77873 27.5399 10.2313 27.7805C13.0181 29.2601 16.2818 29.4586 19.3664 29.4586C23.2997 29.4586 27.2221 28.5838 29.8113 27.0058C31.1748 25.0837 31.984 22.741 31.984 20.2057V11.794C31.984 5.29005 26.7115 0.0175781 20.2076 0.0175781Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M26.7247 18.5236C24.986 18.5236 23.5703 17.1079 23.5703 15.3692C23.5703 13.6305 24.986 12.2148 26.7247 12.2148C28.4634 12.2148 29.8791 13.6305 29.8791 15.3692C29.8791 17.1079 28.4634 18.5236 26.7247 18.5236ZM26.7247 13.4766C25.6817 13.4766 24.8321 14.3262 24.8321 15.3692C24.8321 16.4123 25.6817 17.2619 26.7247 17.2619C27.7678 17.2619 28.6173 16.4123 28.6173 15.3692C28.6173 14.3262 27.7678 13.4766 26.7247 13.4766Z"
                    fill="#2962FF"
                  />
                  <path
                    d="M22.3086 18.5237H21.4675C21.2353 18.5237 21.0469 18.3353 21.0469 18.1031V10.9531H22.3086V18.5237Z"
                    fill="#2962FF"
                  />
                  <path
                    d="M18.5236 12.4251V12.8617C17.9945 12.4613 17.3434 12.2148 16.631 12.2148C14.8923 12.2148 13.4766 13.6305 13.4766 15.3692C13.4766 17.1079 14.8923 18.5236 16.631 18.5236C17.3434 18.5236 17.9945 18.2772 18.5236 17.8768V18.1031C18.5236 18.3352 18.712 18.5236 18.9442 18.5236H19.7854V12.4251H18.5236ZM16.631 17.2619C15.5879 17.2619 14.7383 16.4123 14.7383 15.3692C14.7383 14.3262 15.5879 13.4766 16.631 13.4766C17.674 13.4766 18.5236 14.3262 18.5236 15.3692C18.5236 16.4123 17.674 17.2619 16.631 17.2619Z"
                    fill="#2962FF"
                  />
                  <path
                    d="M13.6851 10.9531H6.95574V12.2149H11.4316L6.74545 17.6825H6.76732C6.63021 17.86 6.53516 18.072 6.53516 18.3134V18.5237H12.844C13.0761 18.5237 13.2645 18.3353 13.2645 18.1031V17.2619H8.78866L13.4748 11.7943H13.453C13.5901 11.6168 13.6851 11.4048 13.6851 11.1634V10.9531Z"
                    fill="#2962FF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5245_36677">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="flex flex-col items-center gap-8">
              <span className="text-body-medium" style={{ color: '#818589' }}>
                Zalo
              </span>
              <span className="text-body-medium max-w-[200px] truncate">
                {CONST.laNhaZalo}
              </span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CenterSupportPage;
